// @mui
import { alpha } from '@mui/material/styles';
import {
  Link,
  Stack,
  Button,
  Tooltip,
  IconButton,
  ButtonProps,
  IconButtonProps,
} from '@mui/material';
//
import Iconify from './Iconify';

// ----------------------------------------------------------------------

export type SocialLinks = {
  facebook?: string;
  telegram?: string;
  discord?: string;
  instagram?: string;
  linkedin?: string;
  twitter?: string;
};

export const defaultSocialLinks: SocialLinks =  {
    discord: 'https://discord.gg/Y6E8ekzrCG',
    telegram: 'https://t.me/+rgGUd3KywjAyZDhl',
    twitter: 'https://twitter.com/agilely_io'
};

type IProps = IconButtonProps & ButtonProps;

interface Props extends IProps {
  simple?: boolean;
  initialColor?: boolean;
  links?: SocialLinks;
}

export default function SocialsButton({
  initialColor = false,
  simple = true,
  links = defaultSocialLinks,
  sx,
  ...other
}: Props) {
  const SOCIALS = [
    {
      name: 'Discord',
      icon: 'jam:discord',
      socialColor: '#E02D69',
      path: links.discord || '#discord-link',
    },
    {
      name: 'Telegram',
      icon: 'cib:telegram-plane',
      socialColor: '#007EBB',
      path: links.telegram || '#telegram-link',
    },
    {
      name: 'Twitter',
      icon: 'jam:twitter',
      socialColor: '#00AAEC',
      path: links.twitter || '#twitter-link',
    },
  ];

  return (
    <Stack direction="row" flexWrap="wrap" alignItems="center" justifyContent="center">
      {SOCIALS.map((social) => {
        const { name, icon, path, socialColor } = social;
        return simple ? (
          <Link key={name} href={path} target="_blank">
            <Tooltip title={name} placement="top">
              <IconButton
                color="inherit"
                sx={{
                  ...(initialColor && {
                    color: socialColor,
                    '&:hover': {
                      bgcolor: alpha(socialColor, 0.08),
                    },
                  }),
                  ...sx,
                }}
                {...other}
              >
                <Iconify icon={icon} sx={{ width: 24, height: 24 }} />
              </IconButton>
            </Tooltip>
          </Link>
        ) : (
          <Button
            key={name}
            href={path}
            color="inherit"
            variant="outlined"
            size="small"
            startIcon={<Iconify icon={icon} />}
            sx={{
              m: 0.5,
              flexShrink: 0,
              ...(initialColor && {
                color: socialColor,
                borderColor: socialColor,
                '&:hover': {
                  borderColor: socialColor,
                  bgcolor: alpha(socialColor, 0.08),
                },
              }),
              ...sx,
            }}
            {...other}
          >
            {name}
          </Button>
        );
      })}
    </Stack>
  );
}
